import React from "react";
import { Modal } from "antd";

const ModalComponent = ({
  isOpen = false,
  setIsOpen,
  title,
  children,
  width,
  onCancel = () => {},
  closable = true,
}) => {
  const handleCancel = () => {
    onCancel();
    setIsOpen(false);
  };

  return (
    <Modal
      open={isOpen}
      closeIcon={false}
      onCancel={handleCancel}
      footer={false}
      maskClosable={false}
      width={width}
      keyboard={false}
    >
      <div className="relative">
        {closable && (
          <div className="flex justify-end items-center px-4 py-3 w-fit absolute -top-5 -right-3">
            <svg
              onClick={handleCancel}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="#0BAFD4"
              className="w-6 h-6 cursor-pointer duration-300 hover:fill-primary"
            >
              <path
                fillRule="evenodd"
                d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        )}

        {title && (
          <p
            className={`text-center title text-[#2F2B3D] mt-0 ${
              closable ? "" : "mt-7"
            }`}
          >
            {title}
          </p>
        )}

        <div className="!pb-0 md:p-6 p-3">{children}</div>
      </div>
    </Modal>
  );
};

export default ModalComponent;
